document.addEventListener('DOMContentLoaded', function () {
  const sections = document.querySelectorAll('.blog-hero-slider');

  sections.forEach(function (section) {
    const swiperEl = section.querySelector('.blog-hero-slider__swiper');
    const bgEl = section.querySelector('.blog-hero-slider__bg');
    const prevEl = section.querySelector('.blog-hero-slider__arrow--prev');
    const nextEl = section.querySelector('.blog-hero-slider__arrow--next');
    const paginationEl = section.querySelector('.blog-hero-slider__pagination');

    if (!swiperEl) return;

    const realSlides = parseInt(swiperEl.dataset.realSlides, 10) || 0;

    function changeBg(swiper) {
      const activeSlide = swiper.slides[swiper.activeIndex];
      if (!activeSlide || !bgEl) return;

      const bg = activeSlide.getAttribute('data-bg');
      if (bg) {
        bgEl.style.backgroundImage = `url("${bg}")`;
      }
    }

    new Swiper(swiperEl, {
      loop: true,
      centeredSlides: true,

      // SP：1件表示
      slidesPerView: 1,
      spaceBetween: 16,

      speed: 700,
      grabCursor: true,

      autoplay: {
        delay: 5500,
        disableOnInteraction: false
      },

      navigation: {
        prevEl: prevEl,
        nextEl: nextEl
      },

      pagination: {
        el: paginationEl,
        clickable: true,
        renderBullet: function (index, className) {
          if (index >= realSlides) return '';
          return `<span class="${className}"></span>`;
        }
      },

      on: {
        init: function () {
          changeBg(this);
        },
        slideChangeTransitionStart: function () {
          changeBg(this);
        }
      },

      breakpoints: {
        768: {
          // PC・タブレット：左右見切れ表示
          slidesPerView: 'auto',
          spaceBetween: 24
        }
      }
    });
  });
});